import {parseGraphQLResponse} from '@github-ui/item-picker-base/api/graphql'
import {useMutation} from '@github-ui/react-query'
import type {CreateLabelMutation} from '@github-ui/server-persisted-queries/types/CreateLabel'

import {apiCreateLabel, type CreateLabelRequest} from '../api/api-create-label'

export type CreateLabelMutationLabel = NonNullable<NonNullable<CreateLabelMutation['createLabel']>['label']>

export const useCreateLabelMutation = () => {
  return useMutation<CreateLabelMutationLabel | null, Error, CreateLabelRequest>({
    mutationFn: async (request: CreateLabelRequest) => {
      const responseJson = await apiCreateLabel(request)
      const responseData = parseGraphQLResponse(responseJson)
      return responseData.data.createLabel?.label ?? null
    },
  })
}
